<template>
 <div class="Home">
    <loader v-show="loader"/>
    <masternav/>
    <br>
    <div class="container-fluid">
       <b-row>
       <b-col lg class="d-none d-sm-none d-md-none d-lg-block"></b-col>
       <b-col lg="8">
        <div class="mobile_call_usa">
          <a style="color: #169a5a;" href="tel:+1 866-961-3133">{{$t('masternav.call_usa')}}  <b>(+1) 866-961-3133</b></a>
          <hr>
        </div>
           <reservar/>
       </b-col>
       <b-col lg class="d-none d-sm-none d-md-none d-lg-block"></b-col>
       </b-row>
    </div>
    <br>
    <maincontent/>
    <br>
    <hr>
    <contactcomp/>
    <br>
    <mainfooter/>
 </div> 
</template>

<script>
// @ is an alias to /src
import masternav           from '@/components/masternav.vue'
import maincontent         from '@/components/maincontent.vue'
import mainfooter          from '@/components/mainfooter.vue'
import rents               from '@/components/rents.vue'
import footsecondary       from '@/components/footsecondary.vue'
import contactcomp         from '@/components/contactcomp.vue'
import reservestep1and2    from '@/components/reservestep1and2.vue'
import loader                     from '@/components/loader.vue'

import reservar            from '@/components/reserva/reservar_modificar'

import { mapState }         from 'vuex'
export default {
  name: 'Home',
  metaInfo: {
      title: "Enterprise Panama | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
  components: {
    masternav,
    mainfooter,
    maincontent,
    rents,
    footsecondary,
    contactcomp,
    reservestep1and2,
    loader,

    //nuevo
    reservar,
  },
  computed: {
    ...mapState('autenticacion', ['loader'])
  },
}
</script>

<style>
@media only screen and (min-width: 600px) {
  .mobile_call_usa {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .mobile_call_usa {
    text-align: center;
  }
}
</style>




